/** Speaking/writing task from the book. It is AI-graded, so here it opens the tutor chat. */
import type { Lesson } from '../../core/content.ts';
import { useTutor } from '../../state/tutor.tsx';
import { routes, useRouter } from '../../state/router.tsx';

export function TaskStep({ lesson, taskId, onDone }: { lesson: Lesson; taskId: string; onDone: () => void }) {
  const { navigate } = useRouter();
  const { setDraft } = useTutor();
  const task = lesson.tasks.find((t) => t.id === taskId);
  if (!task) return null;
  const topic = task.topic_zh ?? task.prompt_zh ?? task.instruction ?? '';

  return (
    <div className="stack stack--24">
      <p className="t-caps">{task.kind === 'speaking' ? 'Разговор по теме' : 'Письмо'} · {task.source}</p>
      <article className="card stack">
        <h2 className="t-card han">{topic}</h2>
        {task.questions && (
          <ol className="task__questions han">
            {task.questions.map((q) => (
              <li key={q}>{q}</li>
            ))}
          </ol>
        )}
        {task.words && <p className="han">Слова: {task.words.join('、')}</p>}
        {task.usefulPhrases && (
          <div className="row task__phrases">
            {task.usefulPhrases.map((p) => (
              <span key={p} className="chip">
                {p}
              </span>
            ))}
          </div>
        )}
        <p className="t-meta">
          Это задание проверяет ИИ-учитель (оценка ИИ). Он задаст вопросы и подскажет, но не ответит за вас.
        </p>
        <button
          type="button"
          className="btn btn--secondary"
          onClick={() => {
            setDraft(`Давай потренируем задание урока «${lesson.title.text}»: ${topic}`);
            navigate(routes.chat);
          }}
        >
          Обсудить с учителем
        </button>
      </article>
      <div className="lesson__footer">
        <button type="button" className="btn btn--primary btn--block" onClick={onDone}>
          Продолжить
        </button>
      </div>
    </div>
  );
}
